import React, { ChangeEvent, Component, useState } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import ServiceDescriptions from "@my-dld/assets/strings/svc_description";
import { LocaleValue } from "@eres/core/dist/LocaleValue";
import { navigate } from "@my-dld/utils/StoreUtils";
import { LocaleUtil, StringUtil } from "@eres/core";
import { TWIMC } from "@my-dld/utils/TabuServices";
import { SSO_USER, TABU_OWNER } from "@10x/sso/roles";
import { checkRole } from "@10x/sso";
import { getAppServices } from "@10x/coreapp";
import { isEmailVerified } from "@my-dld/utils/User";
import { showUnverifiedEmailError } from "@my-dld/utils/UIUtils";
import { Gated } from "@10x/feature-gate";
import { AppIcon, IconName } from "./AppIcon";

export interface ServiceCard {
	id: string;
	label: LocaleValue | string;
	userRole?: number;
	path?: string;
	action?: ( id: string ) => void;
	description?: string;
	descriptionProvider?: any;
	hide?: boolean;
	allowUnverifiedEmailUsers: boolean;
	requiredFeature?: string;
	count?: number;
	requireUaePassUser?: boolean;
	icon?: IconName;
	extraBodyClass?: string;
}


const QLinks: ServiceCard[] = [
	{
		id: "dashboard",
		label: LVStrings.my_dashboard,
		path: "/mydld",
		allowUnverifiedEmailUsers: true,
	},
	{
		id: "twimc",
		label: TWIMC.Name as LocaleValue,
		path: "/mydld/taburequest/twimc",
		userRole: TABU_OWNER.id,
		allowUnverifiedEmailUsers: false,
	},
	{
		id: "profile",
		label: LVStrings.my_profile,
		path: "/mydld/profile",
		allowUnverifiedEmailUsers: true,
	},
	{
		id: "chpwd",
		label: LVStrings.change_password,
		path: "/mydld/profile/chpwd",
		userRole: SSO_USER.id,
		allowUnverifiedEmailUsers: true,
	},
];

interface Props {
	hideQLinks?: boolean;
	services?: ServiceCard[];
	serviceDescProvider?: any;
	title?: string;
	showSearch?: boolean;
	descStringPool?: string;
	hideTitle?: boolean;
	extraContainerClass?: string;
}

class ServiceContainer extends Component<Props> {
	render() {
		const { hideQLinks, services, title, showSearch, descStringPool, extraContainerClass, hideTitle = false } = this.props;
		let nodes = <>
			<ServiceSection
				hideTitle={ hideTitle }
				title={ title ?? Strings.services } services={ services } showSearch={ showSearch } extraContainerClass={ extraContainerClass }
				descStringPool={ descStringPool }/>
			{ !hideQLinks && <ServiceSection title={ Strings.quick_links } services={ QLinks }/> }
		</>;
		return nodes;
	}
}

interface ServiceSectionProps {
	services?: ServiceCard[];
	title: string;
	hideTitle?: boolean;
	showSearch?: boolean;
	descStringPool?: string;
	extraContainerClass?: string;
}

function ServiceSection( props: ServiceSectionProps ) {
	const { title, services, showSearch, descStringPool, extraContainerClass, hideTitle = false } = props;
	const [ query, setQuery ] = useState<string>( "" );
	const classValue = extraContainerClass ? extraContainerClass : "col-md-12";
	if ( services == null || services.length == 0 )
		return null;

	const onChange = ( e: ChangeEvent<HTMLInputElement> ) => {
		const value = e.target.value;
		setQuery( value );
	};

	const nodes = <>
		{ services.filter( ( service: ServiceCard ) => {
			if ( service.userRole == undefined )
				return true;
			return checkRole( service.userRole );
		} ).filter( ( service: ServiceCard ) => {
			if ( !StringUtil.isEmptyStringOrNull( query.trim() ) )
				return LocaleUtil.getLocalValue( service.label ).toLocaleLowerCase().trim().includes( query.toLowerCase().trim() );
			return true;
		} ).map( ( value: ServiceCard, index: number ) => {
			return <ServiceCardItem key={ index } service={ value } descStringPool={ descStringPool }/>;
		} ) }
	</>;
	return <div className={ classValue }>
		<div className="content-section">
			{ !hideTitle ? <div className="section-title">
				<h5>{ title }</h5>
			</div> : null }
			{ showSearch && <div className="input-group field-with-icon field-style mb-3">
				<input
					type="text" className="form-control" placeholder="Search"
					onChange={ onChange }/>
				<div className="input-group-append">
					<button className="btn btn-input-group" type="button">
						<i className="fa fa-search"/>
					</button>
				</div>
			</div>
			}
		</div>
		<div className="row my-dld-action head-card g-2">
			{ nodes }
		</div>
	</div>;
}

export default ServiceContainer;

interface SideBarItemProps {
	service: ServiceCard;
	onClick?: ( id?: string ) => void;
	descStringPool?: string;
}

export function ServiceCardItem( props: SideBarItemProps ) {
	const { service, descStringPool } = props;
	const { id, label, path, action, description, descriptionProvider } = service;
	let desc = description;
	if ( StringUtil.isEmptyStringOrNull( desc ) ) {
		if ( descriptionProvider && descriptionProvider[ id ] ) desc = LocaleUtil.getLocalValue( descriptionProvider[ id ] );
	}
	if ( StringUtil.isEmptyStringOrNull( desc ) && descStringPool ) {
		const appStrings = getAppServices().assetService.Strings( descStringPool );
		desc = appStrings && appStrings[ id ] ? appStrings[ id ] : "";
	}
	if ( StringUtil.isEmptyStringOrNull( desc ) ) {
		if ( ( ServiceDescriptions as any )[ id ] ) desc = LocaleUtil.getLocalValue( ( ServiceDescriptions as any )[ id ] );
	}
	if ( Strings[ "svc_card_desc_" + id ] ) {
		desc = Strings[ "svc_card_desc_" + id ];
	}
	const Card = <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
		<a
			href="#" onClick={ e => {
			e.preventDefault();
			const oAction = () => {
				if ( path ) {
					navigate( path );
				} else if ( action ) {
					action( id );
				}
			};
			if ( service.allowUnverifiedEmailUsers ) {
				oAction();
			} else {
				if ( isEmailVerified() ) {
					oAction();
				} else {
					showUnverifiedEmailError();
				}
			}
		} } className="card">
			<>
				{ service.count !== undefined && service.count !== 0 &&
					<span className="badge-count">{service.count}</span>}
				<span className="service-icon"><i className={"icon-mydld-" + id}></i></span>
				<span className="service-name">{ LocaleUtil.getLocalValue( label ) }</span>
				<span className="service-description">
                    { desc }
                </span>
			</>
		</a>
	</div>;
	if ( service.requiredFeature ) {
		return <Gated featureId={ service.requiredFeature }>{ Card }</Gated>;
	}

	return Card;
}
